<script setup lang="ts">
import Footer from '@/components/footer.vue'
</script>

<template>
  <RouterView />
  <Footer/>
</template>
